import { getBrands as getBrandsAPI, getBrandRegistrationCodes as getBrandRegistrationCodesAPI } from '../api/brands';
import { applyTagToBrands as applyTagToBrandsAPI, deleteBrandTag as deleteBrandTagAPI } from '../api/tags';

export const GET_BRANDS_SUCCESS = 'GET_BRANDS_SUCCESS';
export const GET_BRAND_REGISTRATION_CODES_SUCCESS = 'GET_BRAND_REGISTRATION_CODES_SUCCESS';

export const APPLY_TAG_TO_BRANDS_REQUEST = 'APPLY_TAG_TO_BRANDS_REQUEST';
export const APPLY_TAG_TO_BRANDS_SUCCESS = 'APPLY_TAG_TO_BRANDS_SUCCESS';
export const DELETE_BRAND_TAG_REQUEST = 'DELETE_BRAND_TAG_REQUEST';
export const DELETE_BRAND_TAG_SUCCESS = 'DELETE_BRAND_TAG_SUCCESS';

export const getBrands = (params = {}) => async (dispatch, getState) => {
  const brands = await getBrandsAPI(params);
  return dispatch({
    type: GET_BRANDS_SUCCESS,
    brands
  });
};

export const getBrandRegistrationCodes = () => async dispatch => {
  const codesResponse = await getBrandRegistrationCodesAPI();
  return dispatch({
    type: GET_BRAND_REGISTRATION_CODES_SUCCESS,
    codes: codesResponse.registrationCodes
  });
};

export const applyTagToBrands = (tag, brands) => async (dispatch, getState) => {
  dispatch({
    type: APPLY_TAG_TO_BRANDS_REQUEST,
    tag,
    brands
  });
  await applyTagToBrandsAPI(tag, brands);
  return dispatch({
    type: APPLY_TAG_TO_BRANDS_SUCCESS,
    tag,
    brands
  });
};

export const deleteBrandTag = (tag, brand) => async (dispatch, getState) => {
  dispatch({
    type: DELETE_BRAND_TAG_REQUEST,
    tag,
    brand
  });
  await deleteBrandTagAPI(tag, brand);
  return dispatch({
    type: DELETE_BRAND_TAG_SUCCESS
  });
};
